import React, { useEffect, useState } from "react";
import "../../styles/desktop/notificacao.css";

const Notificacao = ({ trocarPagina, setFiltro, eventos }) => {
  const [pendentes, setPendentes] = useState(0);
  const [emAndamento, setEmAndamento] = useState(0);
  const [concluidoPendente, setConcluidoPendente] = useState(0);
  const [piscar, setPiscar] = useState(false);



  // Atualiza a contagem sempre que os eventos mudam
  useEffect(() => {
    console.log("Eventos em notificação:", eventos);
      // Função para classificar registros com base nos eventos recebidos
    const classificarRegistros = () => {
      if (!eventos || eventos.length === 0) return;

      setPendentes(eventos.filter((evento) => evento.chamado_status === "Pendente").length);
      setEmAndamento(eventos.filter((evento) => evento.chamado_status === "Em andamento").length);
      setConcluidoPendente(eventos.filter((evento) => evento.chamado_status === "Concluído/Pendente").length);
    };
    classificarRegistros();
  }, [eventos]); // Atualiza os contadores quando os eventos recebidos do `Main` mudam

  // Controle de piscar
  useEffect(() => {
    const intervaloPiscar = setInterval(() => {
      setPiscar((prev) => !prev);
    }, 1000);
    return () => clearInterval(intervaloPiscar);
  }, []);

  return (
    <div className="CampoNotificacao">
      <div
        className={`ObjetoNotificacao ${piscar && pendentes > 0 ? "blink-laranja" : ""}`}
        onClick={() => {
          trocarPagina("history");
          setFiltro("Pendente");
        }}
      >
        <p>Pendentes: {pendentes}</p>
      </div>
      <div
        className="ObjetoNotificacao"
        onClick={() => {
          trocarPagina("history");
          setFiltro("Em Andamento");
        }}
      >
        <p>Em Andamento: {emAndamento}</p>
      </div>
      <div
        className={`ObjetoNotificacao ${piscar && concluidoPendente > 0 ? "blink-laranja" : ""}`}
        onClick={() => {
          trocarPagina("history");
          setFiltro("Concluído/Pendente");
        }}
      >
        <p>Concluído/Pendente: {concluidoPendente}</p>
      </div>
    </div>
  );
};

export default Notificacao;
